import React from 'react';
import ThemeLanguageBar from './ThemeLanguageBar';
import Video from './Video';
import ServiceHighlights from './ServiceHighlights';
import LandingPricingCta from './LandingPricingCta';
import LandingFaq from './LandingFaq';
import { LANDING_CPM_NIS, RAICMAN_GRADUATE_CPM_NIS } from '../config/pricingFactors';
import './RaicmanPage.css';

const asset = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const REICHMAN_NAME = 'רייכמן';

const WHATSAPP_PREAMBLE = `שלום, אני בוגר/ת תכנית ${REICHMAN_NAME} ומעוניין/ת לפרסם ב-GSRadio במחיר מבצע לבוגרים (₪12 CPM).`;

function RaicmanPage() {
  return (
    <div className="App landing-page-wrap raicman-page-wrap">
      <ThemeLanguageBar />

      <section className="raicman-hero" dir="rtl">
        <header className="raicman-header">
          <img
            src={asset('/raicman-logo.png')}
            alt={REICHMAN_NAME}
            className="raicman-logo"
          />
          <img src={asset('/logo.png')} alt="GSRadio" className="raicman-gs-logo" />
        </header>
        <p className="raicman-badge">מבצע בלעדי לבוגרי תכנית {REICHMAN_NAME}</p>
        <h1 className="raicman-title">פרסום ב-Android TV לבוגרי {REICHMAN_NAME}</h1>
        <p className="raicman-lead">
          הציגו את העסק שלכם בפרסומות וידאו במסכי Android TV — Partner TV, Yes ועוד — עם תעריף
          מיוחד לבוגרים.
        </p>
      </section>

      <Video />
      <ServiceHighlights />
      <LandingPricingCta
        cpm={RAICMAN_GRADUATE_CPM_NIS}
        title="תמחור CPM לבוגרים"
        subtitle={`₪${RAICMAN_GRADUATE_CPM_NIS} לכל 1,000 הצגות וידאו במקום ₪${LANDING_CPM_NIS} הרגיל`}
        compareCpm={LANDING_CPM_NIS}
        savingsText={`חיסכון של 20% לבוגרי ${REICHMAN_NAME}`}
        whatsappPreamble={WHATSAPP_PREAMBLE}
        sectionClassName="raicman-pricing"
        cardClassName="raicman-pricing-card"
      />
      <LandingFaq />

      <p className="raicman-footnote" dir="rtl">
        המבצע מיועד לבוגרי תכנית {REICHMAN_NAME} בלבד. התעריף הסופי יאושר בהצעה מסחרית.
      </p>
    </div>
  );
}

export default RaicmanPage;
